"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var insertExternalHtmlPlugin = {
  init: function init(editor) {
    editor.addCommand('insert-external-html', {
      editorFocus: true,
      exec: function exec(editor, data) {
        editor.insertHtml(data.html);
        return true;
      }
    });
  }
};
var _default = insertExternalHtmlPlugin;
exports.default = _default;